<template>
  <div class="detail-drawer">
    <div class="data-box">
      <div class="flex mb-3">
        <div class="font-semibold">{{ topInfo.investigatorName }}-{{ topInfo.investigatorPhone }}</div>
        <div class="tag">评分{{ item.score }}</div>
      </div>
      <div class="flex mb-2">
        <div class="num-item">
          执行问卷调查项目：<span>{{ topInfo.wjProjects }}</span>
        </div>
        <div class="num-item">
          上报答卷数：<span>{{ topInfo.reportAnswers }}</span>
        </div>
        <div class="num-item">
          已审答卷数：<span>{{ topInfo.auditAnswers }}</span>
        </div>
        <div class="num-item">
          审核通过率：<span>{{ Math.round(topInfo.auditPassRatio) }}%</span>
        </div>
      </div>
      <!-- <div class="flex">
        <div class="num-item">
          执行明察暗访项目：<span>{{ item.inspect_project }}</span>
        </div>
        <div class="num-item">
          上报案件数：<span>{{ item.report_case }}</span>
        </div>
        <div class="num-item">
          已审案件数：<span>{{ item.audit_case }}</span>
        </div>
        <div class="num-item">
          审核通过率：<span>{{ item.case_pass_ratio }}</span>
        </div>
      </div> -->
    </div>
    <div class="table-list">
      <div class="left-list">
        <!-- 基础信息 -->
        <div class="list-item basic-info" :data-id="navigationList[0].value">
          <div class="title">基础信息</div>
          <DataTable :index="true" :border="true" :data="basicInfoData" :columns="basicInfoColumns" :showPage="false">
            <!-- 上传文件的展示 -->
            <template #answer="{ row }">
              <div v-if="row.questionType !== 18">{{row.answer}}</div>
            <el-image v-else-if="showImg(row.answer)"  style="width: 120px" :src="baseURL + row.answer" :preview-src-list="bigImgUrl" @click="showBigImg(row.answer)" />
            <el-button v-else type="text" @click="openFill(row.answer)">{{decodeURIComponent(row.answer) | fillName}}</el-button>
            </template>
          </DataTable>
        </div>
        <!-- 明察暗访 -->
        <!-- <div class="list-item light-dark" :data-id="navigationList[1].value">
          <div class="title">执行明察暗访项目</div>
          <div class="number">
            执行项目数 <span>88888</span> 个，上报案件数 <span>999</span> 个，案件审核通过率 <span>98%</span>
          </div>
          <DataTable
            height="300px"
            :data="tableData"
            :columns="tableColumns"
            :page="page"
            :showPage="true"
            @pagination-current-change="handleCurrentChange"
          >
            <template #operation="{ row }">
              <el-button type="text" @click="checkDetail(row)">查看详情</el-button>
            </template>
          </DataTable>
        </div> -->
        <!-- 问卷调查 -->
        <div class="list-item survey-investigation" :data-id="navigationList[1].value">
          <div class="title">执行问卷调查项目</div>
          <div class="number">
            执行项目数 <span>{{ wjProjectDetailHeadNum.totalSurveyProjects }}</span> 个，上报答卷数
            <span>{{ wjProjectDetailHeadNum.totalReportAnswers }}</span> 个，答卷审核通过率
            <span>{{ Math.round(wjProjectDetailHeadNum.avgAuditPassRatio) }}%</span>
          </div>
          <DataTable
            height="300px"
            :data="wjProjectDetailData"
            :columns="wjProjectDetailColumns"
            :page="wjProjectDetailPage"
            :showPage="true"
            @pagination-current-change="handleWjProjectCurrentChange"
          >
            <template #answerPassRatio="{ row }">
              <span>{{ Math.round(row.answerPassRatio) }}%</span>
            </template>
            <!-- 操作 -->
            <template #operation="{ row }">
              <el-tooltip
                effect="light"
                :content="row.deleted ? '问卷已删除，无法查看' : '您无此项目，无法查看详情'"
                placement="top"
                :disabled="!row.unableShow"
              >
                <span
                  ><el-button type="text" @click="checkWjProjectDetail(row)" :disabled="row.unableShow"
                    >查看详情</el-button
                  ></span
                >
              </el-tooltip>
            </template>
          </DataTable>
        </div>
        <!-- 评价数据 -->
        <!-- <div class="list-item comment-data" :data-id="navigationList[3].value">
          <div class="title">评价数据</div>
          <div class="number">总评价数 <span>888</span> ，总平均分 <span>2.5</span></div>
          <DataTable
            height="300px"
            :data="tableData"
            :columns="columns"
            :page="page"
            :showPage="true"
            @pagination-current-change="handleCurrentChange"
          >
          </DataTable>
        </div> -->
        <!-- 费用结算记录 -->
        <div class="list-item settlement" :data-id="navigationList[2].value">
          <div class="title">费用结算记录</div>
          <div class="number">
            结算项目数量 <span>{{ settleProjectDetailHeadNum.totalSettleProject }}</span> 个，结算总金额
            <span>{{ settleProjectDetailHeadNum.totalSettleAmount }}</span> 元
          </div>
          <DataTable
            height="300px"
            :data="settleProjectDetailData"
            :columns="settleProjectDetailColumns"
            :page="settleProjectDetailPage"
            :showPage="true"
            @pagination-current-change="handleSettleProjectCurrentChange"
          >
            <!-- 操作 -->
            <template #operation="{ row }">
              <el-tooltip effect="light" content="您无此项目，无法查看详情" placement="top" :disabled="row.own">
                <span
                  ><el-button type="text" @click="checkSettleProjectDetail(row)" :disabled="!row.own">查看详情</el-button></span
                >
              </el-tooltip>
            </template>
          </DataTable>
        </div>
        <!-- 操作记录 -->
        <div class="list-item operation-record" :data-id="navigationList[3].value">
          <div class="title">操作记录</div>
          <DataTable
            height="300px"
            :data="operationRecordData"
            :columns="operationRecordColumns"
            :page="operationRecordPage"
            :showPage="true"
            @pagination-current-change="handleOperationRecordCurrentChange"
          />
        </div>
      </div>
      <aside class="right-hash">
        <ul @click="clickNav">
          <li
            v-for="(item, index) in navigationList"
            :data-value="item.value"
            :key="index"
            class="cursor-pointer p-1"
            :class="{ 'li-active': liActiveClick[item.value] || liActiveScroll[item.value] }"
          >
            {{ item.label }}
          </li>
        </ul>
      </aside>
    </div>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import DataTable from '@/components/base/DataTable'
import {
  basicInfoColumns,
  wjProjectDetailColumns,
  wjProjectDetailPage,
  settleProjectDetailColumns,
  settleProjectDetailPage,
  operationRecordColumns,
  operationRecordPage
} from './config'
import {
  wjProjectDetail,
  settleProjectDetail,
  investigatorInfoDetail,
  getInvestigatorAnswerAuditLogDetail
} from '@/api/more-app/investigator-base'

export default {
  name: 'InvestigatorDetailDrawer',
  components: { DataTable },
  props: {
    isAdmin: {
      type: Boolean,
      default: true
    },
    phone: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      baseURL: window.location.origin + '/fill/api/v1/download?fileName=',
      imgType: ['.png', '.jpeg', '.jpg', '.bmp', '.gif'],
      bigImgUrl: [''],
      // 调查员详情
      topInfo: {},
      basicInfoData: [],
      basicInfoColumns,
      // 调查员执行问卷项目详情
      wjProjectDetailData: [],
      wjProjectDetailColumns,
      wjProjectDetailPage,
      wjProjectDetailHeadNum: {},
      // 调查员费用结算记录详情
      settleProjectDetailData: [],
      settleProjectDetailColumns,
      settleProjectDetailPage,
      settleProjectDetailHeadNum: {},
      // 调查员操作记录
      operationRecordData: [],
      operationRecordColumns,
      operationRecordPage,
      navigationList: [
        { label: '基础信息', value: 'basicInfo' },
        // { label: '执行明察暗访项目', value: 'lightDark' },
        { label: '执行问卷调查项目', value: 'surveyInvestigation' },
        // { label: '评价数据', value: 'commentData' },
        { label: '费用结算记录', value: 'settlement' },
        { label: '操作记录', value: 'operationRecord' }
      ],
      liActiveScroll: {
        basicInfo: true
      },
      liActiveClick: {}
    }
  },
  filters: {
    fillName(val) {
      return val.split('_')[1]
    }
  },
  methods: {
    // 打开表格中的文件
    openFill(val) {
      window.open(this.baseURL + val)
    },
    // 设置大图路径
    showBigImg(val) {
      this.bigImgUrl = [`${this.baseURL + val}`]
    },
    // 表格中的图片是否展示
    showImg(val) {
      if(!val) return ''
      return this.imgType.some(item => val.includes(item))
    },
    required() {
      throw new Error('Paramete is required')
    },
    throttle(fn = this.required(), delay = 200) {
      return function () {
        if (this.timer) return
        this.timer = setTimeout(() => {
          fn()
          this.timer = null
        }, delay)
      }
    },
    handleScroll() {
      const dom = document.getElementsByClassName('left-list')[0]
      dom.addEventListener(
        'scroll',
        this.throttle(() => {
          const list = Array.from(document.getElementsByClassName('list-item'))
          list.forEach(el => {
            if (Math.ceil(dom.scrollTop) >= el.offsetTop - 280) {
              this.liActiveScroll = {}
              this.liActiveClick = {}
              this.liActiveScroll[el.dataset.id] = true
            }
          })
          //滚动条到底
          const totalHeight = Math.ceil(dom.scrollTop + dom.clientHeight)
          if (totalHeight === dom.scrollHeight || totalHeight === dom.scrollHeight + 1) {
            this.liActiveScroll = {}
            this.liActiveClick = {}
            this.liActiveClick[list[list.length - 1].dataset.id] = true
            this.liActiveScroll[list[list.length - 1].dataset.id] = true
          }
        }, 200)
      )
    },
    clickNav(e) {
      const dom = document.getElementsByClassName('left-list')[0]
      const list = Array.from(document.getElementsByClassName('list-item'))
      list.forEach(el => {
        if (el.dataset.id === e.target.dataset.value) {
          dom.scrollTop = Math.ceil(el.offsetTop) - 200
          this.liActiveScroll = {}
          this.liActiveClick = {}
          this.liActiveClick[el.dataset.id] = true
        }
      })
    },
    // 获取调查员详情
    getInvestigatorInfoDetail() {
      investigatorInfoDetail({ phone: this.phone })
        .then(res => {
          if (res.data.code !== 0) return
          if (res.data.data.basicInfos.length === 0) {
            res.data.data.basicInfos = [
              { answer: res.data.data.investigatorName, title: '姓名' },
              { answer: res.data.data.investigatorPhone, title: '手机号' }
            ]
          }
          this.basicInfoData = res.data.data.basicInfos
          this.topInfo = res.data.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取调查员执行问卷项目详情
    getWjProjectDetail() {
      let params = {
        phone: this.phone,
        descs: 'create_time',
        size: this.wjProjectDetailPage.pageSize,
        current: this.wjProjectDetailPage.currentPage
      }
      wjProjectDetail(params)
        .then(res => {
          if (res.data.code !== 0) return
          let data = res.data.data
          this.wjProjectDetailHeadNum = {
            avgAuditPassRatio: data.avgAuditPassRatio,
            totalReportAnswers: data.totalReportAnswers,
            totalSurveyProjects: data.totalSurveyProjects
          }
          this.wjProjectDetailData = data.wjProjectDetail.records
          this.wjProjectDetailPage.total = data.wjProjectDetail.total
          this.wjProjectDetailData.forEach(item => {
            if(item.deleted) {
              item.unableShow = true
            } else {
              item.unableShow = false
              if(!item.own) item.unableShow = true
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 调查员执行问卷项目详情的分页操作
    handleWjProjectCurrentChange(val) {
      this.wjProjectDetailPage.currentPage = val
      this.getWjProjectDetail()
    },
    // 调查员执行问卷项目详情的查看详情操作
    checkWjProjectDetail(row) {
      this.$router.push({ path: `/survey/${row.wjId}/data/data-download` })
    },
    // 获取调查员费用结算项目详情
    getSettleProjectDetail() {
      let params = {
        phone: this.phone,
        descs: 'create_time',
        size: this.settleProjectDetailPage.pageSize,
        current: this.settleProjectDetailPage.currentPage
      }
      settleProjectDetail(params)
        .then(res => {
          if (res.data.code !== 0) return
          let data = res.data.data
          this.settleProjectDetailHeadNum = {
            totalSettleAmount: (Math.round(data.totalSettleAmount * 100) / 100).toFixed(2),
            totalSettleProject: Math.floor(data.totalSettleProject)
          }
          this.settleProjectDetailData = data.settleProjectDetail.records
          this.settleProjectDetailPage.total = data.settleProjectDetail.total
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 调查员费用结算项目分页
    handleSettleProjectCurrentChange(val) {
      this.settleProjectDetailPage.currentPage = val
      this.getSettleProjectDetail()
    },
    // 调查员费用结算项目查看详情
    checkSettleProjectDetail(row) {
      const url = `${window.location.origin}${process.env.VUE_APP_PRE_URL}#/relate-detail/relate-approval/${
        row.statement_id
      }?settleObjType=${row.settle_obj_type ?? ''}&typePage=approval`
      window.open(url)
    },
    // 获取调查员操作记录详情
    getInvestigatorAnswerAuditLogDetail() {
      let params = {
        phone: this.phone,
        size: this.operationRecordPage.pageSize,
        current: this.operationRecordPage.currentPage,
        descs: 'create_time'
      }
      getInvestigatorAnswerAuditLogDetail(params).then(res => {
        if(res.data.code !== 0 || res.data.data === null) return
        this.operationRecordPage.total = res.data.data.total
        let data = res.data.data.records
        this.operationRecordData = data.map(item => {
          let obj = {
            title: item?.questionDetails?.content?.text || '',
            oldAnswer: '',
            newAnswer: '',
            editTime: item.editTime || '',
            editorName: item.editorName || '',
            editorPhone: item.editorPhone || '',
          }
          item.oldAnswerContentItem.forEach((unit, index) => {
            obj.oldAnswer += unit.value
            if(index === item.oldAnswerContentItem.length - 1) return
            obj.oldAnswer += '/'
          })
          item.newAnswerContentItem.forEach((unit, index) => {
            obj.newAnswer += unit.value
            if(index === item.newAnswerContentItem.length - 1) return
            obj.newAnswer += '/'
          })
          return obj
        })
      })
      .catch(err => {
        console.log(err)
      })
    },
    // 调查员操作记录项目分页
    handleOperationRecordCurrentChange(val) {
      this.operationRecordPage.currentPage = val
      this.getInvestigatorAnswerAuditLogDetail()
    }
  },
  mounted() {
    this.handleScroll()
    this.getInvestigatorInfoDetail()
    this.getWjProjectDetail()
    this.getSettleProjectDetail()
    this.getInvestigatorAnswerAuditLogDetail()
  }
}
</script>

<style scoped lang="scss">
.detail-drawer {
  @apply h-full p-4 bg-card-bg-gray text-theme-black-850 text-medium-x leading-22;
  font-family: PingFangSC-Medium;
  .data-box {
    @apply p-4 bg-white rounded-sm mb-4;
    .tag {
      @apply px-2 ml-2 bg-yellow-theme leading-5 text-white text-small;
      border-radius: 10px;
    }
    .num-item {
      @apply flex-1 text-medium;
      span {
        @apply text-medium-x font-semibold;
      }
    }
  }
  .table-list {
    height: calc(100% - 120px);
    @apply flex w-full;
    .title {
      @apply font-semibold pb-4;
    }
    .number {
      @apply text-medium text-right pb-4;
      span {
        @apply text-medium-x;
      }
    }
    .left-list {
      @apply pr-4 h-full overflow-auto;
      width: calc(100% - 164px);
      .basic-info {
        @apply bg-white p-4 rounded-sm mb-4;
        .card {
          @apply w-full bg-theme-gray p-4 text-theme-text-gray text-medium leading-22 box-border rounded-sm;
          font-family: PingFangSC-Regular;
          min-height: 325px;
          div {
            @apply w-full text-medium text-theme-text-gray leading-22;
          }
        }
      }
      .light-dark {
        @apply bg-white p-4 mb-4;
      }
      .survey-investigation {
        @apply bg-white p-4 mb-4;
      }
      .comment-data {
        @apply bg-white p-4 mb-4;
      }
      .settlement {
        @apply bg-white p-4 mb-4;
      }
      .operation-record {
        @apply bg-white p-4 mb-4;
      }
    }
    .right-hash {
      width: 164px;
      font-family: PingFangSC-Regular;
      @apply text-medium text-theme-black-850 leading-22 pl-4;
      div {
        @apply mb-2;
      }
    }
  }
}
.li-active {
  color: #1890ff;
}
</style>
